export default "__VITE_ASSET__BBDMRQ3r__"